<template>
  <v-content>
    <v-container class="fill-height azul" fluid>
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12 py-1">
            <v-img
              height="77"
              src="@/assets/images/logo.png"
              class="ma-5 pa-5"
              contain
            ></v-img>
            <v-toolbar color="#1B6BAA" dark flat>
              <v-toolbar-title>Password Reset</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div v-if="processing" class="text-center py-5">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="64"
                  class="mb-4"
                ></v-progress-circular>
                <p class="text-h6">Resetting your password...</p>
              </div>

              <div v-else-if="success" class="text-center py-5">
                <v-icon size="80" color="success" class="mb-4">
                  mdi-check-circle
                </v-icon>
                <h2 class="text-h5 mb-4" style="color: #1B6BAA;">
                  Password Successfully Reset!
                </h2>
                <v-alert type="success" text class="mb-4">
                  Your password has been successfully changed. Please check your
                  email for your temporary password.
                </v-alert>
                <p class="mb-4">
                  <strong>Important:</strong> Change your temporary password as
                  soon as possible after logging in.
                </p>
                <v-btn color="primary" large to="/login" class="mt-3">
                  <v-icon left>mdi-login</v-icon>
                  Go to Login
                </v-btn>
              </div>

              <div v-else-if="error" class="text-center py-5">
                <v-icon size="80" color="error" class="mb-4">
                  mdi-alert-circle
                </v-icon>
                <h2 class="text-h5 mb-4" style="color: #d32f2f;">
                  Reset Link Invalid or Expired
                </h2>
                <v-alert type="error" text class="mb-4">
                  {{ errorMessage }}
                </v-alert>
                <p class="mb-4">
                  Please request a new password reset link.
                </p>
                <v-btn color="primary" large to="/forgot-password" class="mt-3">
                  <v-icon left>mdi-lock-reset</v-icon>
                  Request New Link
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<style scoped>
.azul {
  background: #1b6baa;
}
</style>

<script>
export default {
  data: () => ({
    email: "",
    token: "",
    processing: true,
    success: false,
    error: false,
    errorMessage: "",
  }),
  methods: {
    resetPassword: function() {
      var este = this;

      var variables = {
        email: este.email,
        token: este.token,
      };

      este.$http
        .post(este.$api + "resetPassword", variables)
        .then(function(response) {
          window.console.log(response);
          if (response.status == 200 && response.data.status == "ok") {
            este.success = true;
            este.processing = false;
          } else {
            este.error = true;
            este.processing = false;
            este.errorMessage =
              response.data.msg ||
              "Invalid or expired reset token. Please request a new one.";
          }
        })
        .catch(function(err) {
          este.error = true;
          este.processing = false;
          este.errorMessage = "An error occurred. Please try again.";
          window.console.log(err);
        });
    },
  },
  mounted: function() {
    if (this.$store.getters.token) {
      this.$router.push("/");
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    this.token = urlParams.get("token") || "";
    this.email = urlParams.get("email") || "";

    if (!this.token || !this.email) {
      this.error = true;
      this.processing = false;
      this.errorMessage =
        "Invalid reset link. Missing token or email parameter.";
    } else {
      this.resetPassword();
    }
  },
};
</script>
